import { Injectable, inject } from '@angular/core';
import {
  BulkOperationType,
  BulkEditValidator,
  BulkValidationResult,
  BulkReviewRow,
} from '@ps/survey-utils';

import { SurveyMarginValidatorService } from './margin/survey-margin-validator.service';
import { BulkEditPanelStateManager } from '../../bulk-edit-panel-state.manager';

const isValidRowWithId = (
  row: unknown,
): row is BulkReviewRow & { id: number } => {
  return (
    typeof row === 'object' &&
    row !== null &&
    'id' in row &&
    typeof (row as BulkReviewRow & { id: number }).id === 'number'
  );
};

@Injectable({ providedIn: 'root' })
export class BulkOperationDataValidatorFactory {
  private readonly _marginValidator = inject(SurveyMarginValidatorService);
  private readonly _stateManager = inject(BulkEditPanelStateManager);

  private readonly _validators = new Map<BulkOperationType, BulkEditValidator>([
    ['margin', this._marginValidator],
  ]);

  public getValidator(operation: BulkOperationType): BulkEditValidator | null {
    return this._validators.get(operation) ?? null;
  }

  public validateBulkPatch(operation: BulkOperationType): BulkValidationResult {
    const validator = this.getValidator(operation);

    if (!validator) {
      return { isValid: true };
    }

    let hasErrors = false;

    for (const row of this._stateManager.records()) {
      if (!validator.isValid(row)) {
        hasErrors = true;

        if (isValidRowWithId(row)) {
          this._stateManager.updateDefaultErrorInRecord(
            row.id,
            validator.message,
          );
        }
      }
    }

    if (hasErrors) {
      return {
        isValid: false,
        error: validator.message,
      };
    }

    return { isValid: true };
  }
}
